



























import { defineComponent, inject, onBeforeUnmount, ref } from "@vue/composition-api";
import { cloneDeep, isEqual } from "lodash-es";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import BaseChip from "@/components/BaseChip";
import BaseIcon from "@/components/BaseIcon";
import HashtagsSetupView from "../../../HashtagsSetupView";
import SchedulePostView from "../../../SchedulePostView";
import OptionItem from "../OptionItem";

export default defineComponent({
  name: "OptionHashtags",
  components: { OptionItem, BaseChip, BaseIcon, SchedulePostView, HashtagsSetupView },
  props: {
    postData: { type: Object as () => ContentSet, required: true },
  },
  setup(props) {
    const selectedTags = ref<string[]>(cloneDeep(props.postData.tagIds));
    const setUpdateCb = inject<(cb: () => Promise<void>) => void>("setUpdateCb", async () => {});
    const removeCb = inject<(cb: () => Promise<void>) => void>("removeCb", async () => {});

    const getTitle = (isOpen: boolean) => {
      return selectedTags.value && selectedTags.value.length && !isOpen
        ? $t("Hashtags {0}", [selectedTags.value.length])
        : $t("Set hashtags");
    };

    const updateHashtags = async () => {
      if (isEqual(selectedTags.value, props.postData.tagIds)) return;
      await providers.ContentSetProvider.update({
        data: {
          id: props.postData.id,
          tagIds: selectedTags.value,
        },
      });
    };

    setUpdateCb(updateHashtags);
    onBeforeUnmount(() => {
      removeCb(updateHashtags);
    });

    const toggleTag = (tag: TagInfo, value: boolean) => {
      if (value) {
        selectedTags.value.push(tag.id);
      } else {
        selectedTags.value = selectedTags.value.filter(id => id !== tag.id);
      }
    };

    const onReset = () => {
      selectedTags.value = [];
    };

    return {
      getTitle,
      onReset,
      toggleTag,
      selectedTags,
    };
  },
});
